import "core-js/modules/es.array.push.js";
// // 二次封装axios
// //引入axios
// import axios from "axios";
// const service = axios.create({
//   // baseURL: 'http://192.168.2.17:8082', //公共接口
//   baseURL: 'http://192.168.2.52:9683',
//   headers: {
//     'Content-Type': 'application/json;charset=UTF-8'
//   },
//   timeout: 30000, //超时时间
// })

// // request 拦截器
// service.interceptors.request.use(
//   config => {
//     // 在这里可以设置请求头、请求参数等return config
//     // if (localStorage.getItem('token')) {  
//     //   config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;  
//     // }  

//     return config
//   },
//   error => {
//     console.log('error',error)
//     return Promise.reject(error)
//   }
// )

// // 响应拦截器  
// service.interceptors.response.use(  
//   response => {
//     const { data } = response
//     if(data.errorCode != 0){
//       ElMessage.error(data.error || '没有返回错误信息，联系管理员')
//     }
//     // 对响应数据做点什么  
//     return response.data; // 直接返回数据，而不是响应对象  
//   },  
//   error => {
//     // 对响应错误做点什么  
//     console.log('响应错误:', error); // for debug 
//     return Promise.reject(error);  
//   }  
// );

// export default service

/**
 * axios封装
 */

//- axios二次封装：https://www.jianshu.com/p/6b626d72ea78
//- axios中文说明：https://www.kancloud.cn/yunye/axios/234845

import axios from 'axios';
import { useRouter, useRoute } from 'vue-router';
import router from '@/router/index';

//- 创建axios实例
var instance = axios.create({
  timeout: 1000 * 180
});
//- 设置默认的接口url前缀（通过node的环境变量判断）
// instance.defaults.baseURL = DOMAIN_LIANTY;
//- 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

//- 响应拦截器
instance.interceptors.response.use(
//- 请求成功
response => {
  if (response.status === 200) {
    const result = response.data;
    if (result.errorCode == 99999 && !result.success) {
      ElMessage.error(result.error || '没有返回错误信息，联系管理员');
      router.push({
        path: '/login'
      });
    } else if (result.errorCode == 11111) {
      ElMessage.error(result.error || '没有返回错误信息，联系管理员');
      router.push({
        path: '/login'
      });
    } else if (result.code != 10000 && !result.success) {
      ElMessage.error(result.error || '没有返回错误信息，联系管理员');
    }
    return Promise.resolve(result);
  } else {
    return Promise.reject(errorText);
  }
},
//- 请求失败
error => {
  return Promise.reject('连接超时，请稍后重试！');
});

/**
 * 将对象转换为query字符串
 *
 * @param  {Object} params [参数对象]
 * @return {String}
 */
const queryParam = params => {
  if (params && Object.keys(params).length > 0) {
    return Object.keys(params).map(k => k + '=' + encodeURIComponent(params[k])).join('&');
  }
  return '';
};

//- 通用请求方法
const request = (method, url, params) => {
  method = method.toLowerCase();
  if (method == 'post') {
    console.log('postparams', params.constructor.name);
    // instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    if (params.constructor.name === 'FormData') {
      return instance.post(url, params);
    }
    return instance.post(url, queryParam(params));
  } else if (method == 'get') {
    return instance.get(url, {
      params
    });
  } else if (method == 'put') {
    return instance.put(url, queryParam(params));
  }
};
//- GET请求
export const requestGet = (url, params) => request('get', url, params);
//- POST请求
export const requestPost = (url, params) => request('post', url, params);
// PUT请求
// export const requestPut = (url, params) => request('put', url, params);
//- formData文件上传
export const requestUpload = (url, params) => {
  return instance({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    data: params
  });
};
export const requestPutBody = (url, params) => {
  return instance({
    method: 'put',
    body: params,
    url
    // headers: {
    //   // 'Content-type': 'application/octet-stream',
    //   'Content-type': 'multipart/form-data',
    // },
  });
};
export default instance;